export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5412.1cf8e785.jpg";